import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { contactRoute } from "constants/routes";
import { Link } from "react-router-dom";
import images from "assets/images";
import get from "lodash/get";

import { getPagedFaqs } from "actions/faq/faq.functions";
import { Loader, SEO } from "components";

import { getPage } from "actions/page/page.functions";

class FAQ extends PureComponent {
  // state = {
  //   visibleId: undefined
  // };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(getPagedFaqs());
    
    let slug = "faq";
    dispatch(getPage(slug));
  }

  // handleSetIsVisible = event => {
  //   const { visibleId } =
  //     event.currentTarget.dataset || event.srcElement.dataset;

  //   this.setState({
  //     visibleId
  //   });
  // };

  render() {
    const { faqs, faqsAreFetching, singlePage } = this.props;
    // const { visibleId } = this.state;

    const seoProps = {
      SEOTitle: get(singlePage, "yoast.title"),
      SEODescription: get(singlePage, "yoast.metadesc"),
      SEOUrl: get(singlePage, "link")
    };

    if (faqsAreFetching)
      return (
        <div className="loader__container">
          <Loader />
        </div>
      );
    if (!faqs && !faqsAreFetching) return null;

    return (
      <main className="view-faq">
        <SEO {...seoProps} />
        <div className="wrapper">
          <div className="view-faq__wrapper">
            <div className="view-faq__heading">
              <h1 className="u-type--beta u-type--primary">FAQ</h1>
            </div>
            <div className="view__faq__content">
              <div className="faq__list">
                {faqs.map(item => (
                  <div key={item.id} className="faq__item">
                    <h2
                      className="faq__item__title u-type--delta"
                      dangerouslySetInnerHTML={{
                        __html: item.title.rendered
                      }}
                    />
                    <p
                      className="faq__item__content formatted"
                      dangerouslySetInnerHTML={{
                        __html: item.content.rendered
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <section className="section section--primary cta">
          <div className="wrapper">
            <div className="cta__layout">
              <div className="cta__layout__content">
                <h3 className="u-type--gamma u-type--primary u-spc-bottom--xlrg">
                  Need a question answered?
                </h3>
                <p className="u-type--zeta u-type--o70 u-spc-bottom--lrg">
                  For more info and support get in touch with a Biond support
                  expert.
                </p>
                <Link
                  to={contactRoute}
                  className="btn btn--secondary btn--med u-rounded"
                >
                  Get in touch
                </Link>
              </div>
              <div className="cta__layout__visual">
                <img alt="Support" src={images.illustrationContactPhone} />
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}

const mapStateToProps = state => {
  const { faqs, faqsAreFetching } = state.faq;
  const { singlePage } = state.pages;

  return { faqs, faqsAreFetching, singlePage };
};

export default connect(mapStateToProps)(FAQ);



// WEBPACK FOOTER //
// ./src/views/FAQ.jsx